
import { Worksheet } from "@/hooks/useWorksheetSearch";

// Check if worksheet has available documents
export const hasAvailableSheets = (worksheet: Worksheet): boolean => {
  return worksheet.document_urls && 
         worksheet.document_urls.length > 0;
};

// Get worksheet ID from selected option
export const getWorksheetIdFromSelection = (worksheetOption: any): number | null => {
  if (!worksheetOption || !worksheetOption.worksheet) {
    return null;
  }
  return worksheetOption.worksheet.id || null;
};

// Process selected worksheet to get subject data in the correct format
export const getSubjectDataFromWorksheet = (worksheet: Worksheet | null): string | null => {
  if (!worksheet) return null;
  
  return JSON.stringify({
    id: worksheet.id,
    name: worksheet.name,
    subject: worksheet.subject,
    grade_level: worksheet.grade_level,
    semester: worksheet.semester,
    document_urls: worksheet.document_urls,
    status: worksheet.status
  });
};
